import styled from "styled-components";

export const StyledDraggableOverlay = styled.div<{
  $disabled?: boolean;
  $axis?: "both" | "vertical";
}>`
  position: absolute;
  max-width: none;
  box-sizing: border-box;
  touch-action: none;
  cursor: ${({ $disabled, $axis }) => {
    if ($disabled) return "default";
    return $axis === "vertical" ? "ns-resize" : "grab";
  }};
  user-select: none;

  &:active {
    cursor: ${({ $disabled, $axis }) => {
      if ($disabled) return "default";
      return $axis === "vertical" ? "ns-resize" : "grabbing";
    }};
  }
`;
